(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    // Move payment icons to bottom bar
    var paymentIcons = document.querySelector('.payment-icons');
    var policyList = document.querySelector('.policy_list');
    if (paymentIcons && policyList) {
      policyList.parentElement.appendChild(paymentIcons);
    }

    // Remove Diners Club, Discover, UnionPay
    var remove = ['Diners Club', 'Discover', 'UnionPay'];
    document.querySelectorAll('.payment-icons__item').forEach(function(item) {
      var title = item.querySelector('title');
      if (title && remove.indexOf(title.textContent.trim()) !== -1) {
        item.remove();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
